import { AccountLessAuthClient } from '../account-less-auth-client';
import { Failed, Success } from '../request';
/**
 * Shared implementation for challenge creation and verification
 */
export async function createChallenge(baseUrl, request, options) {
    const client = new AccountLessAuthClient(baseUrl);
    const response = await client.createChallenge(request, options);
    const body = await response.json();
    if (!response.ok) {
        return Failed(body);
    }
    const nonce = body.challenge?.nonce;
    if (!nonce) {
        throw new Error('Nonce was not returned from server');
    }
    const verify = async (code) => {
        const response = await client.verifyChallenge({
            ...request,
            challengeResponse: { nonce, code },
        }, options);
        const body = await response.json();
        if (!response.ok) {
            return Failed(body);
        }
        const token = body.token;
        if (!token) {
            throw new Error('Token was not returned from server');
        }
        return Success('token', body.token);
    };
    return Success('verify', verify);
}
//# sourceMappingURL=challenge-implementation-helper.js.map